package com.example.borshi.web.nutritionist.models

/**
 * Nutritionist profile with credentials and information
 * Part of the Nutritionist Module - can be extracted as independent module
 */
data class NutritionistProfile(
    val nutritionistId: String = "",
    val name: String = "",
    val credentials: String = "",
    val specializations: List<String> = emptyList(),
    val experience: Int = 0,
    val rating: Double = 0.0,
    val totalClients: Int = 0,
    val activeClients: Int = 0,
    val bio: String = "",
    val profileImage: String = "",
    val contactEmail: String = "",
    val phone: String = "",
    val isActive: Boolean = true,
    val createdAt: Long = 0,
    val updatedAt: Long = 0
)


/**
 * Navigation views for nutritionist dashboard
 */
enum class NutritionistView(val displayName: String) {
    DASHBOARD("Dashboard"),
    PATIENTS("Patients"),
    PLANS("Plans"),
    FOOD_CATALOG("Food Catalog"),
    MESSAGING("Messages"),
    BIOMARKERS("Biomarkers"),
    PROFILE("Profile")
}

